import fetch from 'auth/FetchInterceptor';

const AuthService = {};

AuthService.login = function (data) {
	return fetch({
		url: '/auth/login',
		method: 'post',
		data: data,
	});
};

AuthService.passwordLessLogin = function (data) {
	return fetch({
		url: '/passwordless/login',
		method: 'get',
		params: data,
	});
};

AuthService.passwordLessSendLink = function (data) {
	return fetch({
		url: '/passwordless/send-link',
		method: 'post',
		data: data,
	});
};

AuthService.forgotPassword = function (email) {
	return fetch({
		url: '/auth/forgot-password',
		method: 'post',
		data: { email },
	});
};

AuthService.resetPassword = function (data) {
	return fetch({
		url: '/auth/reset-password',
		method: 'post',
		data: data,
	});
};

AuthService.registerRequest = function (data) {
	return fetch({
		url: '/auth/local/register-request',
		method: 'post',
		data: data,
	});
};

AuthService.register = function (data) {
	return fetch({
		url: '/auth/local/register',
		method: 'post',
		data: data,
	});
};

AuthService.sendVerificationCode = function (data) {
	return fetch({
		url: '/email/send-verification-code',
		method: 'post',
		data: data,
	});
};

AuthService.logout = function () {
	return fetch({
		url: '/auth/logout',
		method: 'post',
	});
};

AuthService.loginInOAuth = function () {
	return fetch({
		url: '/auth/loginInOAuth',
		method: 'post',
	});
};

export default AuthService;
